var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdderUpHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 15,
    viewBox: "0 0 40 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3L3 0V15H0V3Z",
    fill: "#FAE232"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 15,
    transform: "translate(3)",
    fill: "#FAE232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10L20 5L27 10",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 3L37 0V15H40V3Z",
    fill: "#FAE232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdderUpHover);
export default __webpack_public_path__ + "static/media/adder-up-hover.a0c12f06bd8cb4fd130c65c5fcfe4e76.svg";
export { ForwardRef as ReactComponent };